const participantTypes = {
    LOAD_PARTICIPANT_STREAM: 'LOAD_PARTICIPANT_STREAM',
    NEW_PARTICIPANT: 'NEW_PARTICIPANT'
}

export default participantTypes;